import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ObterArquivoCadernoIdInputDto } from "../domain/DTOs/input/jornal/obter-arquivo-caderno-id.input.dto";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ArquivoCadernoOutputDto } from "../domain/DTOs/output/jornal/arquivo-caderno.output.dto";
import { BaseService } from "./base.service";
import { ObterConteudoCadernoIdInputDto } from "../domain/DTOs/input/jornal/obter-conteudo-caderno-id.input.dto";

@Injectable()
export class CadernoService{
  
  constructor(private readonly baseService: BaseService) {}

  public ObterArquivoCadernoPorId(
    inputDto: ObterArquivoCadernoIdInputDto
  ): Observable<EstruturaRetornoDadosOutputDto<ArquivoCadernoOutputDto>> {
    if(!inputDto.pagina)
      return this.baseService.get(`Caderno/ObterArquivoCadernoPorId?id=${inputDto.id}`);
    else
      return this.baseService.get(`Caderno/ObterArquivoCadernoPorId?id=${inputDto.id}&pagina=${inputDto.pagina}`);
  }

  public ObterConteudoCadernoPorId(
    inputDto: ObterConteudoCadernoIdInputDto
  ): Observable<EstruturaRetornoDadosOutputDto<string>> {
    return this.baseService.get(`Caderno/ObterConteudoCadernoPorId/${inputDto.id}`);
  }
}